var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star_active_40",
    transform: "translate(3.603 0.352)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 40,
    height: 40,
    rx: 8,
    transform: "translate(-3.603 -0.352)",
    fill: "#4060ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M11.066,10.182,15.538,1.13,20,10.185l9.99,1.454-7.232,7.046,1.7,9.95-8.936-4.7-8.937,4.7,1.71-9.95L1.075,11.63Z",
    transform: "translate(0.908 4.615)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_1",
    "data-name": "Intersection 1",
    d: "M8.938,13.734,0,18.43l0-.011L13.521,0,23.4,1.438,16.168,8.484l1.706,9.951Z",
    transform: "translate(7.501 14.817)",
    fill: "#e9edf5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_2",
    "data-name": "Intersection 2",
    d: "M8.911,6.892,0,11.574,8.483,0l9.355,11.538.009.055Z",
    transform: "translate(7.527 21.659)",
    fill: "#c8cfde"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFull);
export default __webpack_public_path__ + "static/media/star-full.a855144319321144ea74dd4974ec1d5b.svg";
export { ForwardRef as ReactComponent };